import { createApp } from "vue";
import { createPinia } from "pinia";
import { Icon } from "@iconify/vue";
import "vue-select/dist/vue-select.css";
import VueCookies from "vue-cookies";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { createVfm } from "vue-final-modal";
import "vue-final-modal/style.css";
import App from "@/App.vue";
import "@/styles.css";

createApp(App)
  .use(VueCookies)
  .use(Toast, {
    hideProgressBar: true,
    newestOnTop: false,
    transition: "Vue-Toastification__fade",
    container: document.getElementById("app"),
  })
  .component("Icon", Icon)
  .use(createPinia())
  .use(createVfm())
  .mount("#app");
